import App from '@/models/App'
import OrderingOrdererOrderItem from '@/models/OrderingOrdererOrderItem'

export default class OrderingOrdererEstimateItem extends App {
    static get entity() {
        return 'OrderingOrdererEstimateItems'
    }

    static all() {
        return this.query().get()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingEstimateId: this.attr(''),
            orderingOrderItemId: this.attr(''),
            currency: this.attr(''),
            unitPrice: this.attr(0),
            price: this.attr(0),
            taxCategory: this.attr(''),
            taxRate: this.attr(0),
            isNotAcceptable: this.attr(false),
            reasonForNotAcceptable: this.attr(''),
            remarks: this.attr(''), // 備考フィールドの追加
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            orderingOrderItem: this.belongsTo(
                OrderingOrdererOrderItem,
                'orderingOrderItemId'
            ),
        }
    }

    static apiConfig = {
        actions: {
            updateItem(orderingShipId, orderingOrderId, orderingEstimateId, orderingEstimateItemId, params) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/estimates/${orderingEstimateId}/items/${orderingEstimateItemId}`,
                    App.patch(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
